import styled from '@emotion/styled';

export const CenteredContainer = styled.div`
    padding: 2rem;
    text-align: center;
`;
